import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(props, _ref) {
    var $, $on, $f7, $f7router, $f7route, $update, children, user, avatar, userLoggedIn, viewTutors, pin, keynumber, safeAttempts, openFingerprint, setSafe, safeCancel, calcAge, updateForm, checkData, checkParentsAndTutor, deleteAvatar, rotateAvatar, storeAvatar, setAvatar, qrscan, save;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            $ = _ref.$, $on = _ref.$on, $f7 = _ref.$f7, $f7router = _ref.$f7router, $f7route = _ref.$f7route, $update = _ref.$update;

            /*
             * Valori iniziali
             */
            children = {}, user = {}, pin = [], keynumber = [], safeAttempts = 3;
            props.children = props.children || myApp.children;

            if (!(props.children !== '_new')) {
              _context10.next = 7;
              break;
            }

            myApp.getChildren(props.children).then(function (obj) {
              return children = obj;
            });
            _context10.next = 11;
            break;

          case 7:
            _context10.next = 9;
            return myApp.user();

          case 9:
            user = _context10.sent;
            children = {
              id: Date.now(),
              activation_code: user.activation_code,
              data: {
                pin: user.data.pin,
                ice: user.data.ice
              },
              username: user.username,
              verified: user.verified
            };

          case 11:
            children.data = children.data || {};
            _context10.next = 14;
            return myStorage.get(children.data.avatar);

          case 14:
            _context10.t1 = _context10.sent;

            if (_context10.t1) {
              _context10.next = 17;
              break;
            }

            _context10.t1 = children.data.avatar;

          case 17:
            _context10.t0 = _context10.t1;

            if (_context10.t0) {
              _context10.next = 20;
              break;
            }

            _context10.t0 = 'static/avatar.svg';

          case 20:
            avatar = _context10.t0;
            userLoggedIn = myApp.userLoggedIn || false;
            /*
             * Evento di pagina: https://framework7.io/docs/router-component.html#component-page-events
             * 
             * Aggiorna user
             * Imposta tastiera numerica PIN
             */

            $on('pageMounted', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;

                      if (!(props.children !== '_new')) {
                        _context.next = 7;
                        break;
                      }

                      _context.next = 4;
                      return myApp.server.getJSON('user/me/children/' + props.children);

                    case 4:
                      children = _context.sent;
                      _context.next = 7;
                      return myApp.setChildren(children);

                    case 7:
                      _context.next = 9;
                      return myStorage.get(children.data.avatar);

                    case 9:
                      _context.t1 = _context.sent;

                      if (_context.t1) {
                        _context.next = 12;
                        break;
                      }

                      _context.t1 = children.data.avatar;

                    case 12:
                      _context.t0 = _context.t1;

                      if (_context.t0) {
                        _context.next = 15;
                        break;
                      }

                      _context.t0 = avatar;

                    case 15:
                      avatar = _context.t0;
                      $update();
                      _context.next = 22;
                      break;

                    case 19:
                      _context.prev = 19;
                      _context.t2 = _context["catch"](0);
                      console.log(_context.t2);

                    case 22:
                      _context.prev = 22;
                      $('#sex').val(children.data.sex);
                      calcAge();
                      return _context.finish(22);

                    case 26:
                      $('.safe').on('click', function (ev) {
                        setSafe($(ev.target).data('number'));
                      });

                    case 27:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 19, 22, 26]]);
            })));
            /*
             * Evento di pagina: pageBeforeIn
             * https://framework7.io/docs/router-component.html#component-page-events
             * 
             * Imposta o controlla PIN
             */

            $on('pageBeforeIn', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if ($f7route.query.pin === 'yes' && !myApp.secureMode) {
                        $f7.popup.open('.popup-safe', false);
                        openFingerprint();
                      }

                    case 1:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })));
            /**
             * Login con dati biometrici (Fingerprint / Analisi del viso)
             * 
             * Usa cordova-plugin-fingerprint-aio
             * cordova plugin add cordova-plugin-fingerprint-aio --variable FACEID_USAGE_DESCRIPTION="Per modificare i tuoi dati personali in sicurezza."
             * https://www.npmjs.com/package/cordova-plugin-ebw-fingerprint-aio
             * 0
             * @returns {undefined}
             */

            openFingerprint = function openFingerprint() {
              if ($f7.device.cordova) {
                var isAvailableSuccess = function isAvailableSuccess() {
                  Fingerprint.show({
                    description: lng.access_with_biometric_message
                  }, successCallback, function (errorCallback) {
                    return console.log(errorCallback);
                  });
                };

                var successCallback = function successCallback(res) {
                  myApp.enableSecure();
                  $('#safe-message').addClass('invisible');
                  $f7.popup.close('.popup-safe');
                  checkData();
                };

                Fingerprint.isAvailable(isAvailableSuccess, function () {
                  return console.log('Fingerprint not available');
                });
              }
            };
            /**
             * Chiede e controlla PIN
             * 
             * @param {type} number
             * @returns {undefined}
             */


            setSafe = function setSafe(number) {
              if (!safeAttempts) return;

              switch (number) {
                case 'null':
                  break;

                case 'back':
                  if (keynumber.length) {
                    keynumber.pop();
                  }

                  break;

                default:
                  if (keynumber.length === 3) {
                    keynumber.push(number);
                    var ok = true;
                    children.data.pin = children.data.pin || [];
                    keynumber.forEach(function (e, i) {
                      if (e !== children.data.pin[i]) ok = false;
                    });

                    if (ok) {
                      $('#safe-message').addClass('invisible');
                      myApp.enableSecure();
                      $f7.popup.close('.popup-safe');
                      checkData();
                    } else {
                      $('#safe-message').removeClass('invisible');
                      keynumber = [];
                      safeAttempts--;
                      $update();
                    }
                  } else {
                    keynumber.push(number);
                  }

              }

              $('.point').removeClass('point-fill');
              keynumber.forEach(function (e, i) {
                return $('.point-' + i).addClass('point-fill');
              });
            };
            /**
             * Annulla controllo PIN
             * 
             * @returns {undefined}
             */


            safeCancel = function safeCancel() {
              $f7router.back();
              $f7.popup.close('.popup-safe', false);
            };
            /*
             * Calcola l'età sulla base della data di nascita
             * @returns {undefined}
             */


            calcAge = function calcAge() {
              var birthdate = new Date(children.data.birthdate);
              var datediff = new Date(Date.now() - birthdate.getTime());
              var age = Math.abs(datediff.getUTCFullYear() - 1970);
              viewTutors = age < 18;
              $update();
            };
            /*
             * Aggiorna user.data alla modifica di un campo
             */


            updateForm = function updateForm(e) {
              children.data[e.target.id] = e.target.value;
              checkParentsAndTutor();
            };

            checkData = function checkData() {
              var dataOk = true; // controlla dati richiesti

              myApp.userDataRequired.split(',').forEach(function (k) {
                if (!children.data[k]) {
                  dataOk = false;
                }
              });

              if (!dataOk) {
                var msg = lng.me_create_children_message;
                $f7.dialog.alert(msg);
              }
            };
            /*
             * Imposta i valori required e validate ai campi parent1, parent2 e tutor
             * sulla base dei diversi valori
             * @returns {undefined}
             */


            checkParentsAndTutor = function checkParentsAndTutor() {
              calcAge();
              if (!viewTutors) return;

              if ($f7.input.validate('#parent1_name') && $f7.input.validate('#parent1_lastname') && $f7.input.validate('#parent1_cf') && $f7.input.validate('#parent2_name') && $f7.input.validate('#parent2_lastname') && $f7.input.validate('#parent2_cf')) {
                $('#tutor_name').prop('required', false);
                $('#tutor_name').prop('validate', false);
                $('#tutor_lastname').prop('required', false);
                $('#tutor_lastname').prop('validate', false);
                $('#tutor_cf').prop('required', false);
                $('#tutor_cf').prop('validate', false);
              } else if ($f7.input.validate('#tutor_name') && $f7.input.validate('#tutor_lastname') && $f7.input.validate('#tutor_cf')) {
                $('#parent1_name').prop('required', false);
                $('#parent1_name').prop('validate', false);
                $('#parent1_lastname').prop('required', false);
                $('#parent1_lastname').prop('validate', false);
                $('#parent1_cf').prop('required', false);
                $('#parent1_cf').prop('validate', false);
                $('#parent2_name').prop('required', false);
                $('#parent2_name').prop('validate', false);
                $('#parent2_lastname').prop('required', false);
                $('#parent2_lastname').prop('validate', false);
                $('#parent2_cf').prop('required', false);
                $('#parent2_cf').prop('validate', false);
              } else {
                $('#tutor_name').prop('required', true);
                $('#tutor_name').prop('validate', true);
                $('#tutor_lastname').prop('required', true);
                $('#tutor_lastname').prop('validate', true);
                $('#tutor_cf').prop('required', true);
                $('#tutor_cf').prop('validate', true);
                $('#parent1_name').prop('required', true);
                $('#parent1_name').prop('validate', true);
                $('#parent1_lastname').prop('required', true);
                $('#parent1_lastname').prop('validate', true);
                $('#parent1_cf').prop('required', true);
                $('#parent1_cf').prop('validate', true);
                $('#parent2_name').prop('required', true);
                $('#parent2_name').prop('validate', true);
                $('#parent2_lastname').prop('required', true);
                $('#parent2_lastname').prop('validate', true);
                $('#parent2_cf').prop('required', true);
                $('#parent2_cf').prop('validate', true);
              }

              $update();
            };
            /*
             * Elimina avatar
             * @returns {undefined}
             */


            deleteAvatar = function deleteAvatar() {
              var old = children.data.avatar;
              $f7.dialog.confirm(lng.delete_image_message, function () {
                children.data.avatar = 'static/default/avatar.svg';
                save().then(function () {
                  avatar = children.data.avatar;
                  $update();
                  myStorage.deleteItem(old);
                }).catch(function () {
                  return children.data.avatar = avatar;
                });
              });
            };
            /**
             * Ruota avatar in senso antiorario di 90°
             * @returns {undefined}
             */


            rotateAvatar = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var old, data;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        $f7.preloader.show();
                        _context3.prev = 1;
                        old = children.data.avatar;
                        _context3.next = 5;
                        return myApp.server.postJSON('user/me/avatar/rotate', {
                          src: children.data.avatar,
                          children: props.children
                        });

                      case 5:
                        data = _context3.sent;
                        children.data.avatar = data.src;
                        avatar = children.data.avatar;
                        _context3.next = 10;
                        return myApp.setChildren();

                      case 10:
                        $update();
                        _context3.next = 13;
                        return storeAvatar(old);

                      case 13:
                        _context3.next = 18;
                        break;

                      case 15:
                        _context3.prev = 15;
                        _context3.t0 = _context3["catch"](1);
                        $f7.alertError(_context3.t0);

                      case 18:
                        _context3.prev = 18;
                        $f7.preloader.hide();
                        return _context3.finish(18);

                      case 21:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[1, 15, 18, 21]]);
              }));

              return function rotateAvatar() {
                return _ref5.apply(this, arguments);
              };
            }();

            storeAvatar = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(toDelete) {
                var b64;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return $f7.fetchImage(children.data.avatar);

                      case 2:
                        b64 = _context4.sent;

                        if (!b64) {
                          _context4.next = 7;
                          break;
                        }

                        _context4.next = 6;
                        return myStorage.set(children.data.avatar, b64);

                      case 6:
                        if (toDelete) myStorage.deleteItem(toDelete);

                      case 7:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function storeAvatar(_x3) {
                return _ref6.apply(this, arguments);
              };
            }();
            /*
             * Apre Action Sheet ed imposta avatar
             * 
             * Usa cordova-plugin-camera
             * https://github.com/apache/cordova-plugin-camera
             * 
             */


            setAvatar = function setAvatar(setAndSave) {
              if (setAndSave !== true && $(setAndSave.target).hasClass('f7-icons')) {
                return;
              }

              if (myApp.device.cordova) {
                $f7.actions.create({
                  buttons: [{
                    label: true,
                    text: lng.image_select_source,
                    color: 'gray'
                  }, {
                    icon: '<i class="icon f7-icons">camera</i>',
                    text: lng.camera,
                    color: 'blue',
                    onClick: function () {
                      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                        var old, data;
                        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                          while (1) {
                            switch (_context5.prev = _context5.next) {
                              case 0:
                                if (!$f7.device.android) {
                                  _context5.next = 6;
                                  break;
                                }

                                _context5.next = 3;
                                return myApp.cordova.cameraAndroidCrop();

                              case 3:
                                avatar = _context5.sent;
                                _context5.next = 9;
                                break;

                              case 6:
                                _context5.next = 8;
                                return myApp.cordova.camera({
                                  front: true,
                                  allowEdit: true,
                                  correctOrientation: true
                                });

                              case 8:
                                avatar = _context5.sent;

                              case 9:
                                $f7.preloader.show();
                                _context5.prev = 10;
                                old = children.data.avatar;
                                _context5.next = 14;
                                return myApp.server.postJSON('user/me/avatar', {
                                  img: avatar,
                                  children: props.children
                                });

                              case 14:
                                data = _context5.sent;
                                children.data.avatar = data.src;
                                _context5.next = 18;
                                return myApp.setChildren(children);

                              case 18:
                                $update();
                                if (setAndSave === true) save();
                                _context5.next = 22;
                                return myStorage.set(data.src, avatar);

                              case 22:
                                myStorage.deleteItem(old);
                                _context5.next = 28;
                                break;

                              case 25:
                                _context5.prev = 25;
                                _context5.t0 = _context5["catch"](10);
                                $f7.alertError(_context5.t0);

                              case 28:
                                _context5.prev = 28;
                                $f7.preloader.hide();
                                return _context5.finish(28);

                              case 31:
                              case "end":
                                return _context5.stop();
                            }
                          }
                        }, _callee5, null, [[10, 25, 28, 31]]);
                      }));

                      function onClick() {
                        return _onClick.apply(this, arguments);
                      }

                      return onClick;
                    }()
                  }, {
                    icon: '<i class="icon f7-icons">photo_on_rectangle</i>',
                    text: lng.gallery,
                    color: 'blue',
                    onClick: function () {
                      var _onClick2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                        var old, data;
                        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                          while (1) {
                            switch (_context6.prev = _context6.next) {
                              case 0:
                                if (!$f7.device.android) {
                                  _context6.next = 6;
                                  break;
                                }

                                _context6.next = 3;
                                return myApp.cordova.cameraAndroidCrop(true);

                              case 3:
                                avatar = _context6.sent;
                                _context6.next = 9;
                                break;

                              case 6:
                                _context6.next = 8;
                                return myApp.cordova.camera({
                                  allowEdit: true,
                                  gallery: true,
                                  correctOrientation: true
                                });

                              case 8:
                                avatar = _context6.sent;

                              case 9:
                                $f7.preloader.show();
                                _context6.prev = 10;
                                old = children.data.avatar;
                                _context6.next = 14;
                                return myApp.server.postJSON('user/me/avatar', {
                                  img: avatar,
                                  children: props.children
                                });

                              case 14:
                                data = _context6.sent;
                                children.data.avatar = data.src;
                                _context6.next = 18;
                                return myApp.setChildren(children);

                              case 18:
                                $update();
                                if (setAndSave === true) save();
                                _context6.next = 22;
                                return myStorage.set(data.src, avatar);

                              case 22:
                                myStorage.deleteItem(old);
                                _context6.next = 28;
                                break;

                              case 25:
                                _context6.prev = 25;
                                _context6.t0 = _context6["catch"](10);
                                $f7.alertError(_context6.t0);

                              case 28:
                                _context6.prev = 28;
                                $f7.preloader.hide();
                                return _context6.finish(28);

                              case 31:
                              case "end":
                                return _context6.stop();
                            }
                          }
                        }, _callee6, null, [[10, 25, 28, 31]]);
                      }));

                      function onClick() {
                        return _onClick2.apply(this, arguments);
                      }

                      return onClick;
                    }()
                  }, {
                    text: lng.cancel,
                    color: 'red'
                  }]
                }).open();
              } else {
                $f7.dialog.alert('Camera non disponibile');
                avatar = 'static/default/avatar.svg';
                children.data.avatar = avatar;
              }
            };
            /*
             * Associa card tramite qrscan
             * @returns {undefined}
             */


            qrscan = /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                var success, result;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        success = /*#__PURE__*/function () {
                          var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(result) {
                            var data;
                            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                              while (1) {
                                switch (_context7.prev = _context7.next) {
                                  case 0:
                                    if (result.text) {
                                      _context7.next = 2;
                                      break;
                                    }

                                    return _context7.abrupt("return");

                                  case 2:
                                    if (!result.text.match(myApp.qrscanpattern)) {
                                      _context7.next = 23;
                                      break;
                                    }

                                    $f7.preloader.show();
                                    _context7.prev = 4;
                                    _context7.next = 7;
                                    return myApp.server.putJSON('user/me/cardnumber?children=' + props.children, result);

                                  case 7:
                                    data = _context7.sent;
                                    $f7.toast.show({
                                      text: lng.associate_card_ok_message,
                                      cssClass: 'bg-color-green text-color-white',
                                      closeTimeout: 3000
                                    });
                                    children.cardnumber = data.cardnumber;
                                    _context7.next = 12;
                                    return myApp.setChildren(children);

                                  case 12:
                                    $update();
                                    _context7.next = 18;
                                    break;

                                  case 15:
                                    _context7.prev = 15;
                                    _context7.t0 = _context7["catch"](4);
                                    $f7.alertError(_context7.t0);

                                  case 18:
                                    _context7.prev = 18;
                                    $f7.preloader.hide();
                                    return _context7.finish(18);

                                  case 21:
                                    _context7.next = 24;
                                    break;

                                  case 23:
                                    $f7.dialog.alert(lng.card_cannot_be_associated);

                                  case 24:
                                  case "end":
                                    return _context7.stop();
                                }
                              }
                            }, _callee7, null, [[4, 15, 18, 21]]);
                          }));

                          return function success(_x4) {
                            return _ref8.apply(this, arguments);
                          };
                        }();

                        if (!myApp.device.cordova) {
                          _context8.next = 7;
                          break;
                        }

                        _context8.next = 4;
                        return myApp.cordova.qrscan();

                      case 4:
                        _context8.t0 = _context8.sent;
                        _context8.next = 10;
                        break;

                      case 7:
                        _context8.next = 9;
                        return $f7.pwaQrcodeScanner();

                      case 9:
                        _context8.t0 = _context8.sent;

                      case 10:
                        result = _context8.t0;

                      case 11:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));

              return function qrscan() {
                return _ref7.apply(this, arguments);
              };
            }();
            /*
             * Salva
             */


            save = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                var inputsvalid, avatarvalid, sexvalid, cardOK, page;
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        inputsvalid = $f7.input.validateInputs('#validate');
                        avatarvalid = avatar !== 'static/avatar.svg';
                        sexvalid = $('#sex').val() !== '-';
                        cardOK = children.cardnumber ? true : false; // Controlla campi richiesti

                        if (!(inputsvalid && avatarvalid && sexvalid && cardOK)) {
                          _context9.next = 25;
                          break;
                        }

                        $f7.preloader.show();
                        _context9.prev = 6;
                        _context9.next = 9;
                        return myApp.server.postJSON('user/me', {
                          usr: children.data,
                          children: props.children
                        });

                      case 9:
                        _context9.next = 11;
                        return myApp.setChildren(children);

                      case 11:
                        // imposta myApp.userLoggedIn
                        userLoggedIn = true; // Mostra messaggio OK

                        $f7.toast.show({
                          text: lng.saved_ok,
                          cssClass: 'bg-color-green text-color-white',
                          closeTimeout: 3000
                        }); // Reindirizza alla pagina dei servizi oppure alla pagina ICE

                        page = children.data.ice ? '/services/' : '/ice/?showNext=yes';
                        window.setTimeout(function () {
                          return $f7router.navigate(page);
                        }, 1500);
                        _context9.next = 20;
                        break;

                      case 17:
                        _context9.prev = 17;
                        _context9.t0 = _context9["catch"](6);
                        $f7.alertError(_context9.t0);

                      case 20:
                        _context9.prev = 20;
                        $f7.preloader.hide();
                        return _context9.finish(20);

                      case 23:
                        _context9.next = 26;
                        break;

                      case 25:
                        if (inputsvalid && sexvalid && cardOK) {
                          // Dati completi ma senza immagine -> Apre procedura per caricare l'immagine
                          setAvatar(true);
                        } else if (inputsvalid && sexvalid) {
                          // Dati completi ma senza card -> Apre procedura per caricare card
                          qrscan();
                        } else {
                          // Dati incompleti -> mostra messaggio
                          $f7.toast.show({
                            text: lng.all_fields_are_required_message,
                            cssClass: 'bg-color-red text-color-white',
                            closeTimeout: 3000
                          });
                        }

                      case 26:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9, null, [[6, 17, 20, 23]]);
              }));

              return function save() {
                return _ref9.apply(this, arguments);
              };
            }();

            return _context10.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">

        ${userLoggedIn && $h`
        <div class="left">
          <a href="/services/" class="link">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        `}

        <div class="title">
          <span class="padding-left"> ${lng.me_title} </span>
        </div>

        <div class="right">
          <a href="#" class="link icon-only panel-open btn-menu" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>

      </div>
    </div>
    <div class="page-content bg-color-white">

      <div class="block">
        <div class="avatar" @click=${setAvatar} style="background-image: url('${avatar}')">
          ${!avatar.match(/avatar\.svg$/) && $h `
          <i class="f7-icons text-color-red" style="border-radius: 50%; background-color: white; padding: 3px" @click="${deleteAvatar}">trash</i>
          <i class="f7-icons text-color-white float-right" style="border-radius: 50%; background-color: rgba(0,0,0,.5); padding: 3px" @click="${rotateAvatar}">crop_rotate</i>
          `}
        </div>
      </div>

      <div class="list no-hairlines-md">
        <ul id="validate">
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.name} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="name" type="text" placeholder="${lng.your_name}" required validate value=${children.data.name} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.lastname} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="lastname" type="text" placeholder="${lng.your_lastname}" required validate value=${children.data.lastname} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.birthdate} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="birthdate" type="date" placeholder="${lng.insert} ${lng.birthdate}" required validate value=${children.data.birthdate} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.gender} *</div>
              <div class="item-input-wrap">
                <select @change=${updateForm} id="sex"  required validate pattern="[^\-]">
                  <option value="-"></option>
                  <option value="M">M</option>
                  <option value="F">F</option>
                  <option value="N">${lng.undeclared}</option>
                </select>
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.address}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="address" type="text" placeholder="${lng.insert} ${lng.address}" required validate value=${children.data.address} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li>
            <div class="row">
              <div class="col-40">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.postal_code}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="cap" type="tel" placeholder="${lng.postal_code}" required validate pattern="[0-9]{5}" value=${children.data.cap}/>
                      <span class="input-clear-button"></span>
                      <div class="item-input-info">${lng.field_required}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-60">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.city}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="city" type="text" placeholder="${lng.insert} ${lng.city}" required validate value=${children.data.city}/>
                      <span class="input-clear-button"></span>
                      <div class="item-input-info">${lng.field_required}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="row">
              <div class="col-40">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.prov}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="district" type="text" placeholder="${lng.prov}" required validate value=${children.data.district} />
                      <span class="input-clear-button"></span>
                      <div class="item-input-info">${lng.field_required}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-60">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.nation}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="country" type="text" placeholder="${lng.nation}" required validate  value=${children.data.country} />
                      <span class="input-clear-button"></span>
                      <div class="item-input-info">${lng.field_required}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.tax_id_code}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm}  class='text-upper' id="cf" type="text" placeholder="${lng.tax_id_code}" required validate pattern="^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$" value=${children.data.cf} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>


          ${viewTutors && $h`
          <h4 class="margin-left">${lng.parent} 1</h4>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 1 ${lng.name} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="parent1_name" type="text" placeholder="${lng.insert} ${lng.name}" required validate value=${children.data.parent1_name} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 1 ${lng.lastname} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="parent1_lastname" type="text" placeholder="${lng.insert} ${lng.lastname}" required validate value=${children.data.parent1_lastname} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 1 ${lng.tax_id_code}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} class='text-upper' id="parent1_cf" type="text" placeholder="${lng.insert} ${lng.tax_id_code}" required validate pattern="^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$" value=${children.data.parent1_cf} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <h4 class="margin-left">${lng.parent} 2</h4>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 2 ${lng.name} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="parent2_name" type="text" placeholder="${lng.insert} ${lng.name}" required validate value=${children.data.parent2_name} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 2 ${lng.lastname} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="parent2_lastname" type="text" placeholder="${lng.insert} ${lng.lastname}" required validate value=${children.data.parent2_lastname} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 1 ${lng.tax_id_code}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} class='text-upper' id="parent2_cf" type="text" placeholder="${lng.insert} ${lng.tax_id_code}" required validate pattern="^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$" value=${children.data.parent2_cf} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <h4 class="margin-left">Tutore</h4>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.tutor} ${lng.name} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="tutor_name" type="text" placeholder="${lng.insert} ${lng.name}" required validate value=${children.data.tutor_name} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.tutor} ${lng.lastname} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="tutor_lastname" type="text" placeholder="${lng.insert} ${lng.lastname}" required validate value=${children.data.tutor_lastname} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.tutor} ${lng.tax_id_code}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} class='text-upper' id="tutor_cf" type="text" placeholder="${lng.insert} ${lng.tax_id_code}" required validate pattern="^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$" value=${children.data.tutor_cf} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          `}

        </ul>

        <div class="block">
          ${!(children.cardnumber || '') ? $h`
          <button @click=${qrscan} class="button button-large button-outline button-round">
            <img src="static/card.png" style="position: absolute; left: 15px" width="38"/> 
            ${lng.associate_card}</button>
          ` : $h`
          <div class='display-flex justify-content-space-around align-items-center'>
            <img style='max-width: 50%' src='static/card.png' />
            <p class='text-align-right padding-left'>${lng.associate_card_message}</p>
          </div>
          `}
        </div>

        <div class="block">
          <button @click=${save} class="button button-large button-fill button-round color-secondary">
            <i class="f7-icons left">square_arrow_right</i> ${lng.save}
          </button>
        </div> 
      </div>
    </div>

    <div class="popup popup-tablet-fullscreen popup-safe display-flex justify-content-center align-items-center flex-direction-column">
      <div class="block text-align-center">
        ${lng.insert_pin_message}
      </div>
      <div class="unselectable" style="width: 100%; max-width: 380px;">
        <div class="row text-align-center" style="max-width: 250px; margin: 0 auto; padding: 25px 0">
          <div class="col">
            <div class="point point-0"></div>
          </div>
          <div class="col">
            <div class="point point-1"></div>
          </div>
          <div class="col">
            <div class="point point-2"></div>
          </div>
          <div class="col">
            <div class="point point-3"></div>
          </div>
        </div>
        <div id="safe-message" class="text-align-center text-color-red invisible">
          ${lng.pin_error_message} <br/> ${lng.attempts_left}: ${safeAttempts}
        </div>
        <div class="block text-align-center">
          <div class="row">
            <div class="col number-key safe" data-number="1">1</div>
            <div class="col number-key safe" data-number="2">2</div>
            <div class="col number-key safe" data-number="3">3</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="4">4</div>
            <div class="col number-key safe" data-number="5">5</div>
            <div class="col number-key safe" data-number="6">6</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="7">7</div>
            <div class="col number-key safe" data-number="8">8</div>
            <div class="col number-key safe" data-number="9">9</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="null"></div>
            <div class="col number-key safe" data-number="0">0</div>
            <div class="col number-key safe" data-number="back"><i class="f7-icons" data-number="back">delete_left</i></div>
          </div>
        </div>
      </div>
      <button class="button button-link text-color-gray" @click=${safeCancel}>Annulla</button>
    </div>

  </div>
`
    }
    );

          case 38:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();